import { combineReducers } from '@reduxjs/toolkit';
import formsList, { FormsListState } from './features/forms/ducks';

export interface HomeState {
  formsList: FormsListState;
}

export default combineReducers({
  formsList,
});
